<template>
  <v-row>
    <v-dialog v-model="showDialog" scrollable max-width="750px">
      <v-card>
        <v-card-title>
          <v-panel>
				<span style="font-size: 20px;">
					{{ !data.id ? $t('wkt.admin.kiosk.edit-kiosk.edit-title-new') : $t('wkt.admin.kiosk.edit-kiosk.edit-title-edit') }}
				</span>
            <!--<v-btn icon style="top: -20px; left: 10px; float: right;">
              <v-icon @click="showDialog=false">close</v-icon>
            </v-btn>-->
          </v-panel>
        </v-card-title>
        <v-card-text>
          <v-container>
						<v-form ref="form">
							<v-row>
								<v-col cols="12">
									<!-- desplegable de empresa -->
									<v-autocomplete
										v-model="data.companyId"
										:items="companies"
										item-text="name"
										item-value="id"
										menu-props="bottom, offsetY"
										:label="$t('wkt.admin.kiosk.edit-kiosk.company')" 										
										@change="updateWorkplaces()" 
									/>
								</v-col>

								<v-col cols="12">                
									<v-text-field
										v-model="data.username"
										:label="$t('wkt.admin.kiosk.edit-kiosk.username')"
										autocomplete="none"
										:rules="[validationRules.required, validationRules.email]"
										max="200"
									/>
								</v-col>

								<v-col cols="12">
									<v-autocomplete
										v-model="data.workplaceId"
										:items="workplaces"
										item-text="name"
										item-value="id"
										menu-props="bottom, offsetY"
										:label="$t('wkt.admin.kiosk.edit-kiosk.workplace')"
									/>
								</v-col>

								<v-col cols="12">                
									<v-text-field
										v-model="data.description"
										:label="$t('wkt.admin.kiosk.edit-kiosk.description')"
										autocomplete="none"
										:rules="[validationRules.required]"
										max="200"
									/>
								</v-col>
														
								<v-col cols="12" sm="6" md="3">
									<span>{{ $t('wkt.admin.kiosk.edit-kiosk.enabled') }}</span>
									<v-radio-group v-model="data.isEnabled" row style="position: relative; top: -15px; max-height: 94px;"
										:rules="[validationRules.requiredBoolean]">
										<v-radio :label="$t('wkt.admin.common.yes')" :value="true"/>
										<v-radio :label="$t('wkt.admin.common.no')" :value="false"/>
									</v-radio-group>
								</v-col>
									<v-col cols="12" sm="6" md="6">
									<span>{{ $t('wkt.admin.kiosk.edit-kiosk.edit.activities') }}</span>
									<v-radio-group v-model="data.allowEditActivities" row style="position: relative; top: -15px; max-height: 94px;"
										:rules="[validationRules.requiredBoolean]">
										<v-radio :label="$t('wkt.admin.common.yes')" :value="true"/>
										<v-radio :label="$t('wkt.admin.common.no')" :value="false"/>
									</v-radio-group>
								</v-col>
							</v-row>
						</v-form>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn v-if="showDeleteButton" color="#ff0000" @click="confirmDelete()">
						<v-icon left color="#ffffff">delete</v-icon>
						<span style="color: #ffffff;">{{ $t('wkt.admin.common.dialog-buttons.delete').toUpperCase() }}</span>
					</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="#185EA9" text @click="ok()" style="font-size: 0.9em; font-weight: 400;">{{ $t('wkt.admin.common.dialog-buttons.ok').toUpperCase() }}</v-btn>
          <v-btn text @click="showDialog=false" style="font-size: 0.9em; font-weight: 400;">{{ $t('wkt.admin.common.dialog-buttons.cancel').toUpperCase() }}</v-btn>
        </v-card-actions>
      </v-card>
			<LoadingDialog :loading="loading" />
    </v-dialog>

		<ConfirmDialog ref="dlgConfirm"
			v-bind:title="$t('wkt.admin.kiosk.edit-kiosk.confirm-dialog.title')"
			v-bind:message="$t('wkt.admin.kiosk.edit-kiosk.confirm-dialog.text')"
			v-bind:titleOk="$t('wkt.admin.common.dialog-buttons.delete')"
			v-bind:titleCancel="$t('wkt.admin.common.dialog-buttons.cancel')"
			v-on:confirmed="deleteItem()"
		/>
  </v-row>	
</template>

<script>
import BaseModule from '../common/BaseModule.js'
import ConfirmDialog from '../common/ConfirmDialog'
import LoadingDialog from '../common/LoadingDialog'
import api from '../../api/worktime'


  export default {
    name: 'KioskDialog',
    mixins: [BaseModule],
		components: {
			ConfirmDialog, LoadingDialog
		},
    data () {
      return {
				loading: false,
        showDialog: false,
        companies: [],
        workplaces: [],
        data: {},
        msgCb: null,
				showDeleteButton: false
      }
    },
    methods: {
			buildEmptyData() {
				var data = {
					id: null,
					companyId: null,
					username: null,
					description: null,
					workplaceId: null,
					isEnabled: true ,
					allowEditActivities: true                   
				};
                
				return data;
			},
      open: function(companies, data, msgCb) {
				if (this.$refs.form) {
					this.$refs.form.resetValidation();
				}

				this.clear();

				// quita las empresas con licencia gratuita
				this.companies = companies.filter((company) => company.licenseType !== 0);

        this.data = data;

				if (this.data) {
					this.updateWorkplaces();
				} else {
					this.data = this.buildEmptyData();
				}

        this.msgCb = msgCb;
				this.showDeleteButton = data != null;
        this.showDialog = true;
      },
			clear() {
        this.companies = [];
        this.workplaces = [];
				this.data = this.buildEmptyData();
			},
      ok: function() {
				if (!this.$refs.form.validate()) {
					return;
				}

				this.loading = true;

				api.storeKiosk(this.data,
					res => {
						this.loading = false;
						this.showDialog = false;
            if (this.msgCb) {
							this.msgCb(res.message, res.rsOK);
						}
					},
					error => {
						this.loading = false;
						this.$log.error(error);
						if (this.msgCb) {
              this.msgCb(error.message, false);
						}
					});
      },
			confirmDelete() {
				this.$refs.dlgConfirm.confirm(this.data);
			},
			deleteItem() {
				this.loading = true;		

				api.deleteKiosk(this.data.id,
					res => {
						this.loading = false;
						this.showDialog = false;
            if (this.msgCb) {
							this.msgCb(res.message, res.rsOK);
						}
					},
					(error) => {
						this.loading = false;
						this.$log.error(error);
						if (this.msgCb) {
              this.msgCb(error.message, false);
						}
					}
				);
			},
      updateWorkplaces() {
        this.loading = true;

				api.getWorkplacesByCompanyId(this.data.companyId,
					data => {
							this.loading = false;
							this.workplaces = data;
							this.workplaces.unshift({ id: null, name: this.$t('wkt.admin.kiosk.edit-kiosk.all_workplaces') });
					}, 
					(error) => {
							this.loading = false;
							console.log(error);
							if (this.msgCb) {
								this.msgCb(error.message, false);
							}
					});
			},
    },
  }
</script>